import React from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';

import CancelIcon from '@mui/icons-material/Cancel';

import { SortableContainer, SortableItem } from '@ts-core/core/components/Sort';

import { ExerciseMediaItem } from '../../types';

import ExerciseMediaItemPreview from '../ExerciseMediaItemPreview';

interface ExerciseMediaItemsListProps {
  sx?: SxProps;
  items?: ExerciseMediaItem[];

  onRemoveItemAtIndex?: (index: number) => void;
  onSortMedia?: (from: number, to: number) => void;
}

const ExerciseMediaItemsList = (props: ExerciseMediaItemsListProps) => {
  const { sx, items = [], onRemoveItemAtIndex, onSortMedia } = props;
  return (
    <Stack width="100%" spacing={1} sx={sx}>
      <SortableContainer items={items} onSort={onSortMedia} renderOverlay={(item) => <ExerciseMediaItemPreview item={item} />}>
        {items.map((item, index) => (
          <SortableItem key={item.id} id={item.id} disableDrag={!onSortMedia}>
            <Box position="relative" height="100%">
              {onRemoveItemAtIndex && (
                <IconButton color="error" sx={{ position: 'absolute', right: -16, top: -16, zIndex: 999 }} onClick={() => onRemoveItemAtIndex(index)}>
                  <CancelIcon />
                </IconButton>
              )}
              <ExerciseMediaItemPreview item={item} />
            </Box>
          </SortableItem>
        ))}
      </SortableContainer>
    </Stack>
  );
};

export default ExerciseMediaItemsList;
